import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useRouteTransition = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    setError(null);

    // Simulate route transition
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timeout);
  }, [location.pathname]);

  return { isLoading, error };
};
